export default __webpack_public_path__ + "static/media/facebook.0674d396.svg";